import React from 'react';
import CharacList, { LAYOUT } from '@/components/CharacList';
import PropTypes from 'prop-types';
import { ModuloCaracteristicasCss } from './styles';

export { LAYOUT };

/**
 * @name ModuloCaracteristicas
 * @description
 * @param {any} props
 * @returns {React.FC}
 */

const ModuloCaracteristicas = ({
  featureList,
  title,
  layout,
  iconProps,
  textInfoProps,
}) => {
  return (
    <>
      <div id="moduloCaracteristicas" className="moduloCaracteristicas ">
        <div className="caracterristica-body container">
          <CharacList
            title={title}
            listadoCaracteristicas={featureList}
            layout={layout}
            iconProps={iconProps}
            textInfoProps={textInfoProps}
          />
        </div>
      </div>
      <style jsx>{ModuloCaracteristicasCss}</style>
    </>
  );
};

ModuloCaracteristicas.propTypes = {
  featureList: PropTypes.array,
  layout: PropTypes.oneOf(Object.values(LAYOUT)),
};

ModuloCaracteristicas.defaultProps = {
  featureList: [],
  layout: LAYOUT.DEFAULT,
};

export default ModuloCaracteristicas;
